<template lang="pug">
.he-no_signal(
			:class="{'he-no_signal--show' : $store.state.general.refreshing , 'he-no_signal--refreshing' : reloading}"

			role="button"
			@click="reloadPage()"
		)
			.he-no_signal-icon
				img.he-no_signal-icon__svg(
					src= "/no-signal.svg", 
					alt="acb live" 
				)
				span.he-no_signal-icon__label {{ $t('No Signal') }}
			.he-no_signal-reload
				i: font-awesome-icon(icon="sync-alt")
		
</template>

<style lang="sass">
.he
    &-no_signal
        display: grid
        position: absolute
        bottom: 1rem
        right: 0
        background-color: $light-grey
        backdrop-filter: blur(3px)
        grid-auto-flow: column
        transition: background-color .4s
        cursor: pointer
        box-sizing: border-box
        font-size: 0.8em
        align-items: center
        box-shadow: 0 0 6px 0px rgba($black, 0.4)
        color: $black
        max-height: 35px
        height: 100%
        z-index: -99
        opacity: 0
        visibility: hidden
        transition: opacity 1s

        &--show
            opacity: 1
            visibility: visible
            z-index: 10


        &-icon
            display: grid
            grid-auto-flow: column
            align-items: center
            grid-gap: 0.25rem
            padding: 0 0.5rem
                

            &__svg
                height: 100%
                max-height: 20px
                path
                    fill: $primary-color
                    
            &__label
                display: none
                +breakpoint(medium)
                    display: initial
                    max-width: 40px
                    word-wrap: break-word
                    line-height: 1.1em
                    text-transform: uppercase
                    font-weight: $bold
                    font-size: 10px
                    font-size: 1.2em

        &-reload
            background-color: $primary-color
            height: 100%
            width: 35px
            display: flex
            justify-content: center
            align-items: center


            & > i
                font-size: 1.4em
                color: $white
                transition: transform 1s
                @media (hover: hover) and (pointer: fine)
                    @at-root .he-no_signal:hover &
                        transform: rotate(90deg)
                @at-root .he-no_signal--refreshing &
                    animation: rotating 1s linear infinite


@keyframes rotating
  from
    transform: rotate(0deg)
    @media (hover: hover) and (pointer: fine)
        transform: rotate(90deg)

  to
    transform: rotate(360deg)

</style>


<script>
export default {
	name: "NoSignal",
	data() {
		return {
            reloading: false
		};
	},
methods: {
	reloadPage(){
        this.reloading = true
		this.$store.commit('general/deactivateRefreshSignal')
		this.$store.commit('general/clearRefreshSignal')
		setTimeout(() => {
            this.$store.commit('general/activateRefreshSignal')
            this.$store.commit('general/setRefreshSignal')
		}, 5);

        setTimeout(() => {
            this.reloading = false
		}, 5000);

		// if (this.$store.state.general.refreshing){
		// 	window.location.reload();
		// }
	},
}
};
</script>
